import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_SEARCH_PHARMACY_MEDICINES_AND_COSMETICS } from "../../action-types/actions";

import i18n from "../../i18n";
export const searchPharmacyMedicinesAndCosmetics = createAsyncThunk(
  ACTIONS_SEARCH_PHARMACY_MEDICINES_AND_COSMETICS.search_medicines_and_cosmetics,
  async (
    { query = "", page = 1, limit = 20, type = "all" },
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      if (!query || query.trim() === "") {
        return rejectWithValue(i18n.t("toast.searchQueryIsRequired"));
      }

      const queryParams = new URLSearchParams({
        query: query.trim(),
        page: page.toString(),
        limit: limit.toString(),
        type,
      });

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.searchPharmacyMedicinesAndCosmetics}?${queryParams.toString()}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        toast.error(
          response?.data?.message || i18n.t("pharmacy.toast.failedToSearchMedicinesAndCosmetics"),
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorSearchingMedicinesAndCosmetics");
      // Don't show toast for validation errors
      if (error?.response?.status !== 400) {
        toast.error(errMsg);
      }
      return rejectWithValue(errMsg);
    }
  },
);
